import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDirectoryNumberRequest, DirectoryNumber } from '../models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultDirectoryNumberResource {
  private http = inject(HttpClient);

  post(request: DefaultDirectoryNumberRequest): Observable<DirectoryNumber> {
    return this.http.post<DirectoryNumber>('/services/cisco/defaults/directory-number', {
      ...request,
    });
  }
}
